import CircularProgress from 'components/CircularProgress';

const ViewLoading = () => {
  return (
    <div className="d-flex flex-fill align-items-center justify-content-center">
      <CircularProgress />
    </div>
  );
};

export default ViewLoading;
